'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = require('reselect');

var _reactRedux = require('react-redux');

var _BreadcrumbList = require('./breadcrumbs/BreadcrumbList');

var _BreadcrumbList2 = _interopRequireDefault(_BreadcrumbList);

var _AccountUtil = require('./utils/account/AccountUtil');

var _AccountUtil2 = _interopRequireDefault(_AccountUtil);

var _NotificationUtil = require('./utils/notifications/NotificationUtil');

var _NotificationUtil2 = _interopRequireDefault(_NotificationUtil);

var _CurrentBoardHeader = require('./CurrentBoardHeader');

var _CurrentBoardHeader2 = _interopRequireDefault(_CurrentBoardHeader);

var _LiveEditingUtil = require('./utils/liveEditing/LiveEditingUtil');

var _LiveEditingUtil2 = _interopRequireDefault(_LiveEditingUtil);

var _ReferUtil = require('./utils/ReferUtil');

var _ReferUtil2 = _interopRequireDefault(_ReferUtil);

var _HelpUtil = require('./utils/help/HelpUtil');

var _HelpUtil2 = _interopRequireDefault(_HelpUtil);

var _mainSelector = require('../main/mainSelector');

require('./AppHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Util
var boardAncestorsSelector = (0, _reselect.createSelector)(_mainSelector.getBreadcrumb, function (state, props) {
    return state.getIn(['app', 'currentUser', 'rootBoardId']);
}, function (breadcrumbObj, rootBoardId) {
    return {
        rootBoardId: rootBoardId,
        breadcrumbObj: breadcrumbObj
    };
});

// Styles


// Components
// Lib


var AppHeaderMobile = function AppHeaderMobile(props) {
    return _react2.default.createElement(
        'header',
        { className: 'AppHeader' },
        _react2.default.createElement(
            'div',
            { className: 'header-section header-tools' },
            _react2.default.createElement(
                'div',
                { className: 'header-left' },
                _react2.default.createElement(_BreadcrumbList2.default, props)
            ),
            _react2.default.createElement(
                'div',
                { className: 'header-right' },
                _react2.default.createElement(_NotificationUtil2.default, { currentUser: props.currentUser }),
                _react2.default.createElement(_AccountUtil2.default, { currentUser: props.currentUser })
            )
        )
    );
};

var AppHeaderDesktop = function AppHeaderDesktop(props) {
    return _react2.default.createElement(
        'header',
        { className: 'AppHeader' },
        _react2.default.createElement(
            'div',
            { className: 'header-section header-tools' },
            _react2.default.createElement(
                'div',
                { className: 'header-left' },
                _react2.default.createElement(_BreadcrumbList2.default, props)
            ),
            _react2.default.createElement(
                'div',
                { className: 'header-right' },
                _react2.default.createElement(_ReferUtil2.default, { currentUser: props.currentUser }),
                _react2.default.createElement(_HelpUtil2.default, null),
                _react2.default.createElement(_LiveEditingUtil2.default, { currentUser: props.currentUser }),
                _react2.default.createElement(_NotificationUtil2.default, { currentUser: props.currentUser }),
                _react2.default.createElement(_AccountUtil2.default, { currentUser: props.currentUser })
            )
        ),
        _react2.default.createElement(_CurrentBoardHeader2.default, props)
    );
};

var AppHeader = function AppHeader(props) {
    return props.isMobileView ? _react2.default.createElement(AppHeaderMobile, props) : _react2.default.createElement(AppHeaderDesktop, props);
};

AppHeader.propTypes = AppHeaderMobile.propTypes = AppHeaderDesktop.propTypes = {
    currentUser: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string.isRequired,
    documentMode: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    isMobileView: _propTypes2.default.bool,
    getDocumentElementSizes: _propTypes2.default.func,
    elementFilter: _propTypes2.default.object,
    breadcrumbObj: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(boardAncestorsSelector)(AppHeader);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/AppHeader.js
// module id = 769
// module chunks = 0